import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover } from 'antd';
import echarts from 'echarts';
import ReactECharts from 'echarts-for-react';
import countriesInfo from '../../config/countriesInfo.json'
import worldJson from '../../config/countries_geo.json';
import TinyTable from './tinyTable';
import { QuestionCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';


import './analytics.css';

// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class CountryCard extends Component {

	async componentDidMount() {
		echarts.registerMap('world', worldJson);/* 注册world地图 */
	}


	onZoom = (code) => {
		if (!this.echartMapRef) {
			return;
		}
		const echartInstance = this.echartMapRef.getEchartsInstance();
		let range = this.coordinatesRange(worldJson.features.find(f => f.properties.name === code).geometry.coordinates);
		let c = countriesInfo.find(e => e.code3 === code);
		if (c) {
			clearTimeout(this.onZoomTimer);
			echartInstance.setOption({
				geo: {
					zoom: Math.ceil(120 / Math.max(range[0], range[1] / 8)) + 1,
					center: [...c.latlong].reverse()
				}
			});
			this.onZoomTimer = setTimeout(() => {
				if (this.echartMapRef) {
					const echartInstance = this.echartMapRef.getEchartsInstance();
					echartInstance.setOption({
						geo: {
							center: [0, 0],
							zoom: 1
						}
					});
				}
			}, 8000);
		}
	}

	onMapClickEvents = (params) => {
		this.onZoom(params.name);
	}

	coordinatesRange = (arrays) => {
		let x = [], y = [];
		const flatten = (arr) => {
			if (typeof arr[0] === "object") {
				for (let arrs of arr) {
					flatten(arrs);
				}
			} else {
				x.push(arr[0]);
				y.push(arr[0]);
			}
		}
		flatten(arrays);
		return [Math.max(...x) - Math.min(...x), Math.max(...y) - Math.min(...y)];
	}

	onSelectCountry = (params) => {
		this.onZoom(params.code);
	}

	render() {
		const { opensearchDailyActiveUserCountryList, loading, userTheme } = this.props;
		let countryCount = [];
		let total = 0
		for (let countryAttempt of opensearchDailyActiveUserCountryList ? opensearchDailyActiveUserCountryList : []) {
			let countryInfo = countriesInfo.find(e => (countryAttempt.key === e.name || countryAttempt.key === e.code));
			if (countryInfo) {
				let index = countryCount.findIndex(e => (e.name === countryInfo.code3));
				if (index < 0) {
					total += countryAttempt.doc_count;
					countryCount.push({ name: countryInfo.code3, country: countryInfo['name-short'] || countryInfo.name, value: countryAttempt.doc_count });
				} else {
					countryCount[index].value += countryAttempt.doc_count;
					total += countryAttempt.doc_count;
				}
			}
		}

		let options = {};
		countryCount = countryCount.sort((a, b) => (b.value - a.value)).map(a => ({ name: a.name, country: a.country, value: Math.log10(a.value), attempts: a.value }));
		options = {
			// backgroundColor: '#404a59',
			backgroundColor: (userTheme === 'dark') ? "#00000080" : "#FFFFFF80",
			title: {},
			geo: {
				show: true,//是否显示地理坐标系组件
				roam: true, //是否允许鼠标滚动放大，缩小
				map: 'world',
				label: { //文本
					position: 'top',
					emphasis: {
						color: (userTheme === 'dark') ? "#FFF" : "#000",
						show: true
					},
					backgroundColor: (userTheme === 'dark') ? "#000" : "#FFF",
					rich: {},
					formatter: function (params) {
						return (countriesInfo.find(e => e.code3 === params.name) || params).name;
					}
				},
				itemStyle: {
					normal: {
						// areaColor: '#323c48',
						borderColor: '#FFFFFF'
					},
					emphasis: {
						areaColor: '#313695'
					}
				},
				center: [0, 0],
				// center,
				// center: [...countriesInfo.find(e=>e.code === 'PH').latlong].reverse(),
				zoom: 1,//起始缩放比例
				// nameMap: nameMap,//世界各国名中英文对应
			},
			tooltip: {
				show: true,
				formatter: function (params) {
					if (params && params.data) {
						return `${params.data.country}: <br><span style="color:#fff">&#x25C9;</span> ${params.data.attempts} views`
					}
				}
			},
			//是视觉映射组件，用于进行『视觉编码』，也就是将数据映射到视觉元素（视觉通道）。
			visualMap: {
				show: false,
				left: 'right',
				min: 0,
				max: (countryCount.length) ? Math.max(...countryCount.map(e => e.value)) : 100000,
				inRange: {
					color: [
						// 			'#abd9e9',
						// 			'#74add1',
						// 			'#4575b4',
						//   '#313695',
						'#D2E9FF',
						'#97CBFF',
						'#46A3FF',
						'#AE0000'
					]
				},
				text: ['High', 'Low'],
				calculable: true,
				seriesIndex: 0,
			},
			series: [
				{
					data: countryCount,
					// mapType: 'world',
					type: 'map',
					geoIndex: 0,
					// roam: true,
					// map: 'world',
					emphasis: {
						label: {
							show: true
						}
					},
				}
			],
		};
		return (
			<Card className="analyticCard">
				<h3 className="title">{`Active Locations  `}
					<Popover placement="topLeft"
						overlayStyle={{ width: '300px' }}
						content={help.find(d => d.name === 'CountryCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={countryCount.slice(0, 50).map(c => ({ country: c.country, watch_events_count: c.attempts, country_code: c.name }))} target="_blank" filename={"Active Locations.csv"}>
						<DownloadOutlined />
					</CSVLink>
					<span className="extra">
						{(countryCount.length > 0) &&
							`Total ${countryCount.length} Different Countries`
						}
					</span></h3>
				<Row>
					<Col span={16}>
						<ReactECharts ref={(e) => { this.echartMapRef = e; }} theme={userTheme} option={options} loadingOption={{ color: "#74add1" }} showLoading={loading} notMerge={true} onEvents={{
							'click': this.onMapClickEvents
						}} />
					</Col>
					<Col span={8}>
						<TinyTable title={["Country", "Watch events count"]} data={countryCount.slice(0, 50).map(c => ({ name: c.country, value: c.attempts, code: c.name, percent: (c.attempts / total) }))} onSelect={this.onSelectCountry.bind(this)} />
					</Col>
				</Row>
			</Card>
		);
	}
}

const mapStateToProps = state => ({
	userTheme: state.user.userTheme,
	opensearchDailyActiveUserCountryList: state.analytics.opensearchDailyActiveUserCountryList,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(CountryCard);
